import dashboardService from "../../../services/dashboardService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_GETBYSTATUSES } from "../../../utils/constants";
import { TicketsByStatuses } from "../../../models/Dashboard";

const useGetByStatus = (year: number) =>
  useQuery<TicketsByStatuses[], Error>({
    queryKey: [CACHE_KEY_GETBYSTATUSES, year],
    queryFn: () => dashboardService.GetTicketByStatuses(year),
  });

export default useGetByStatus;
